import {
  pipe,
  replace,
  join,
  split,
  toLower,
  converge,
  compose,
  toUpper,
  tail,
  lift,
  concat,
  head,
  identity,
  ifElse,
  flip,
  includes,
} from "ramda";
import { notBlank } from "./ext";

export const formatContributorName = contributor => {
  const name =
    contributor.contributorType === "PERSON"
      ? [
          contributor.prefix,
          contributor.firstName,
          contributor.middleName,
          contributor.lastName,
          contributor.suffix,
        ].join(" ")
      : contributor.fullName;

  return [
    name,
    contributor.role ? `(${contributor.role.displayName})` : void 0,
  ].join(" ");
};

export const capitalize = pipe(
  replace(/-/g, "_"),
  split("_"),
  lift(converge(concat, [compose(toUpper, head), compose(toLower, tail)])),
  join(" "),
);

export const formatRoleLabel = pipe(
  split("_"),
  tail,
  lift(
    ifElse(
      flip(includes)(["QA"]),
      identity,
      converge(concat, [compose(toUpper, head), compose(toLower, tail)]),
    ),
  ),
  join(" "),
);

export const formatDateString = date => {
  if (notBlank(date)) {
    const jsDate = new Date(date);
    const year = jsDate.getFullYear();
    const month = ("0" + (jsDate.getMonth() + 1)).slice(-2);
    const day = ("0" + jsDate.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  } else {
    return null;
  }
};

export const formatSort = searchState =>
  `${searchState.orderBy} ${searchState.orderDirection}`;
